import React, {Fragment, Suspense} from 'react';
import Tabs from 'react-responsive-tabs';
import QuickReply from "../QuickReply/index";
import History from "./Subtables/History";
import Activity from "./Subtables/Activity";

function getLeadSubtables () {
    const tabsContent = [
        {
            title: 'Scheduled activities',
            content: <Activity />
        },
        {
            title: 'History',
            content: <History />
        }
    ];
    return tabsContent;
}
function getTabs() {
    let tabsContent = getLeadSubtables();
    return tabsContent.map((tab, index) => ({
        title: tab.title,
        getContent: () => tab.content,
        key: index,
    }));
}


const Subtable = props => {

    return (
        <Fragment>
            <div className="lead-subtable-container">
                <Tabs tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding" transform={false} showInkBar={true} items={getTabs()}/>
            </div>
        </Fragment>

    )


}

export default Subtable;
